import { z } from 'zod';

export const ChatPlatform = z.enum(['twitch', 'youtube', 'kick', 'hypevault']);
export type ChatPlatform = z.infer<typeof ChatPlatform>;

export const ChatBadge = z.enum(['broadcaster', 'mod', 'vip', 'sub', 'verified', 'partner']);
export type ChatBadge = z.infer<typeof ChatBadge>;

export const ChatMessage = z.object({
  id: z.string().uuid(),
  streamerId: z.string().uuid(),
  platform: ChatPlatform,
  viewerId: z.string().nullable(),
  viewerName: z.string(),
  message: z.string(),
  command: z.string().nullable(),
  args: z.array(z.string()),
  badges: z.array(ChatBadge),
  timestamp: z.number().int(),
});
export type ChatMessage = z.infer<typeof ChatMessage>;

export function parseCommand(message: string): { command: string | null; args: string[] } {
  const trimmed = message.trim();
  if (!trimmed.startsWith('!')) return { command: null, args: [] };
  const tokens = trimmed.slice(1).split(/\s+/);
  const command = (tokens[0] ?? '').toLowerCase();
  if (!command) return { command: null, args: [] };
  return { command, args: tokens.slice(1) };
}
